import ReactGA from 'react-ga4';
import config from '../../config';

function convertPathnameToReloadKey(pathname) {
  return pathname;
}

export function recordGAEvent(category, action, label, value) {
  if (config.analytics) {
    ReactGA.event({category, action, label, value});
  }
}

export function recordGAReloadEvent(pathname) {
  recordGAEvent('Navigation', 'reload', convertPathnameToReloadKey(pathname));
}

export function recordGAPageViewEvent() {
  if (config.gtmId || config.analytics) {
    ReactGA.send({
      hitType: 'pageview',
      page: window.location.hostname + window.location.pathname
    });
  }
}
